import type { Descendant } from 'slate'

import type { SerializedRichText } from './types'

export default function serializeRichText(value: Descendant[]): SerializedRichText {
  return { serialization_method: 'slate_json_v1', content: value }
}
